import React, { useRef } from "react";
import { ArrowBack, ArrowForward } from "@mui/icons-material"; // Import Material UI icons
import { Swiper, SwiperSlide } from "swiper/react"; // Import Swiper components
import 'swiper/css';
import 'swiper/css/navigation'; // Ensure navigation styles are imported
import 'swiper/css/pagination'; // Ensure pagination styles are imported
// import { Navigation, Pagination } from "swiper"; // Import necessary modules
// Import images
import screenshot1 from "../utils/images/screenshot/1.jpg";
import screenshot2 from "../utils/images/screenshot/2.jpg";
import screenshot3 from "../utils/images/screenshot/3.jpg";
import screenshot4 from "../utils/images/screenshot/4.jpg";
import screenshot5 from "../utils/images/screenshot/5.jpg";
import screenshot6 from "../utils/images/screenshot/6.jpg";
import screenshot7 from "../utils/images/screenshot/7.jpg";
import screenshot8 from "../utils/images/screenshot/8.jpg";
import screenshot9 from "../utils/images/screenshot/9.jpg";
// import screenshot10 from "../utils/images/screenshot/10.png";

const AppScreenshots = () => {
    const swiperRef = useRef(null);

    const screenshots = [
        screenshot1, screenshot2, screenshot3, screenshot4, screenshot5, screenshot6, screenshot7, screenshot8, screenshot9
    ];

    return (
        <section className="bg-gray-300 py-16">
            <div className="container mx-auto px-6">
                <div className="text-center text-white mb-12">
                    <div className="text-center">
                        <h2 className="text-4xl text-blue-900 font-bold">ऐप के स्क्रीनशॉट</h2>
                        <div className="flex justify-center items-center mt-2">
                            <div className="w-8 h-[2px] bg-blue-950"></div> {/* Line */}
                            <div className="w-2 h-2 bg-blue-950 rounded-full mx-2"></div> {/* Dot */}
                            <div className="w-8 h-[2px] bg-blue-950"></div> {/* Line */}
                        </div>
                    </div>

                </div>

                {/* Swiper Carousel */}
                <div className="relative mx-20">
                    <Swiper
                        // modules={[Navigation, Pagination]} // Add Swiper modules for navigation and pagination
                        ref={swiperRef}
                        loop={true} // Enable loop
                        slidesPerView={4}
                        spaceBetween={20} // Spacing between slides
                        breakpoints={{
                            300: {
                                slidesPerView: 1, // 1 slide per view on small screens
                                spaceBetween: 10,
                            },
                            768: {
                                slidesPerView: 2, // 2 slides per view on medium screens
                                spaceBetween: 10,
                            },
                            1024: {
                                slidesPerView: 3, // 3 slides per view on larger screens
                                spaceBetween: 20,
                            },
                            1280: {
                                slidesPerView: 4, // 4 slides per view on very large screens
                                spaceBetween: 20,
                            },
                        }}
                        pagination={{ clickable: true }} // Enable pagination
                    >
                        {screenshots?.map((screenshot, index) => (
                            <SwiperSlide key={index}>
                                <div className="w-full h-auto flex justify-center items-center">
                                    <img
                                        src={screenshot} // Use the imported image dynamically
                                        alt={`App screenshot img ${index + 1}`}
                                        className="rounded-lg shadow-lg max-w-full h-auto max-h-[500px] object-cover" // Adjust width and height
                                    />
                                </div>

                            </SwiperSlide>
                        ))}
                    </Swiper>

                    <button
                        type="button"
                        className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-1/2 text-blue-950 hover:text-blue-800  p-2 rounded-md"
                        aria-label="Previous"
                        onClick={() => swiperRef.current.swiper.slidePrev()} // Use Swiper's slidePrev method
                        style={{ marginLeft: "-30px" }}
                    >
                        {/* <ArrowBack /> */}
                    </button>

                    <button
                        type="button"
                        className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-1/2 text-blue-950 hover:text-blue-800 p-2 rounded-full"
                        aria-label="Next"
                        onClick={() => swiperRef.current.swiper.slideNext()} // Use Swiper's slideNext method
                        style={{ marginRight: "-30px" }}
                    >
                        {/* <ArrowForward /> */}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default AppScreenshots;
